import React from 'react'
import styled from '@emotion/styled'

import GoodLink from '../GoodLink'
import GoodImage from '../GoodImage'
import GoodSpecialTitle from '../GoodSpecialTitle'
import GoodTitle from '../GoodTitle'
import GoodDescription from '../GoodDescription'
import {GoodPropsList} from '../GoodPropsList'
import AddToCart from '../AddToCart'

const Root = styled.div`
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: stretch;
  margin-bottom: 23px;
  box-shadow: 1px 2px 5px rgba(0, 0, 0, 0.07);
  padding: 20px 25px 30px 20px;
  background-color: white;
`

const ImgBin = styled.div`
  flex-shrink: 0;
`

const InfoBin = styled.div`
  flex: 1;
  margin: 0 0 0 30px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: stretch;
`

const Texts = styled.div`
`

const GoodTitleBin = styled.div`
  margin-bottom: 12px;
`

const PropsAndActions = styled.div`
  margin-top: 18px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const ListGood = ({
  good,
  currentUser,
  activeCatalogType,
  activeCategory,
  quantityInCart,
  setQuantityInCart
}) => {
  const Link = ({children}) => <GoodLink goodId={good.id} activeCatalogType={activeCatalogType} activeCategory={activeCategory}>
    {children}
  </GoodLink>

  return <Root>
    <ImgBin>
      <Link><GoodImage good={good}/></Link>
    </ImgBin>
    <InfoBin>
      <Texts>
        <GoodSpecialTitle good={good} noOutOfStock/>
        <Link>
          <GoodTitleBin>
            <GoodTitle good={good}/>
          </GoodTitleBin>
        </Link>
        <Link><GoodDescription good={good}/></Link>
      </Texts>
      <PropsAndActions>
        <GoodPropsList good={good} currentUser={currentUser} activeCatalogType={activeCatalogType}/>
        <AddToCart
          good={good}
          currentUser={currentUser}
          activeCatalogType={activeCatalogType}
          quantityInCart={quantityInCart}
          setQuantityInCart={setQuantityInCart}
        />
      </PropsAndActions>
    </InfoBin>
  </Root>
}

export default ListGood
